/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Field } from 'react-final-form';
import { StyleSheet } from 'aphrodite';
import { Dropdown } from '@blend/enterprise-components';

import { BlendBridge } from 'blb-types/blendBridge';
import { FinalFormInputConfig } from 'blb-ui-types/helpers';
import { WrappedInput } from 'blb-components/WrappedInput';

const styles = StyleSheet.create({
  selectWrapper: {
    fontWeight: 'bold',
    maxWidth: '50%',
  },
});

const getSelectInputConfig = (
  options: BlendBridge.IOption[],
  promptText: string,
): FinalFormInputConfig<Dropdown.Props, string> => {
  const documentTypeSelectorInputConfig = {
    component: WrappedInput,
    containerStyles: [styles.selectWrapper],
    customComponentProps: { options, valueRequired: true },
    inputComponent: Dropdown,
    label: promptText,
    // TODO: make the name of the options field configurable.
    name: 'selectedDocumentType',
  };

  return documentTypeSelectorInputConfig;
};

interface OptionsProps extends Omit<BlendBridge.API.InputTaskDescription, 'type'> {}

export const Options = ({ promptText, options }: OptionsProps) => {
  if (!options || options.length === 0) {
    return null;
  }

  return (
    <React.Fragment key={promptText}>
      <Field {...getSelectInputConfig(options, promptText)} />
    </React.Fragment>
  );
};
